import sourceIcon from './faCircleChevronRight';

export default {
  prefix: sourceIcon.prefix,
  iconName: sourceIcon.iconName,
  icon: [
    sourceIcon.icon[0],
    sourceIcon.icon[1],
    sourceIcon.icon[2][1],
    sourceIcon.icon[3],
    sourceIcon.icon[4]
  ] };
